var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadCustomers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 33.255 33.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8321",
    "data-name": "Group 8321",
    transform: "translate(-2.6 -2.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24953",
    "data-name": "Path 24953",
    d: "M19.228,3.5a.513.513,0,0,0-.513.513V5.991A13.427,13.427,0,0,0,5.824,18.965H3.763a.513.513,0,1,0,0,1.025H5.828a13.429,13.429,0,0,0,12.887,12.8v2.149a.513.513,0,0,0,1.025,0V32.793a13.429,13.429,0,0,0,12.887-12.8h2.066a.513.513,0,1,0,0-1.025H32.631A13.427,13.427,0,0,0,19.74,5.991V4.013a.513.513,0,0,0-.513-.513ZM31.606,18.965H29.4a.513.513,0,1,0,0,1.025H31.6A12.4,12.4,0,0,1,19.74,31.768V29.645a.513.513,0,0,0-1.025,0v2.123A12.4,12.4,0,0,1,6.854,19.99H9.06a.513.513,0,1,0,0-1.025H6.849A12.4,12.4,0,0,1,18.715,7.016V9.31a.513.513,0,1,0,1.025,0V7.016A12.4,12.4,0,0,1,31.606,18.965Z",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24954",
    "data-name": "Path 24954",
    d: "M34.2,32.241a3.858,3.858,0,0,0,1.4,2.973,4.841,4.841,0,0,0-3.735,4.7v2.731a.513.513,0,0,0,.513.513H43.752a.513.513,0,0,0,.513-.513V39.918a4.841,4.841,0,0,0-3.733-4.7A3.865,3.865,0,1,0,34.2,32.24Zm5.229,3.866a3.815,3.815,0,0,1,3.811,3.81v2.218H32.887V39.918a3.815,3.815,0,0,1,3.811-3.81ZM40.9,32.241A2.841,2.841,0,1,1,38.063,29.4,2.841,2.841,0,0,1,40.9,32.241Z",
    transform: "translate(-18.833 -16.373)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadCustomers);
export default __webpack_public_path__ + "static/media/LeadCustomers.12637b404145911896238af26dcecb4d.svg";
export { ForwardRef as ReactComponent };